import React from 'react'
import { ClipLoader, BarLoader } from 'react-spinners'
import { valuationStatus } from '@utils/valuationStatus'
import { Container, Body, Row, Col, Scroll, Pill } from './styles'

import { CheckCircle, Close } from '@icons'

const DISABLED_STATUS = [0, 1, 3]

const STATUS = {
  0: {
    text: 'Na fila',
    component: (
      <BarLoader
        color={'#A1A9B4'}
        sizeUnit={'px'}
        height={16}
        width={16}
        loading
      />
    ),
  },
  1: {
    text: 'Processando',
    component: (
      <ClipLoader color={'#A1A9B4'} sizeUnit={'px'} size={16} loading />
    ),
  },
  2: { text: 'Concluído', component: <CheckCircle width={16} height={16} /> },
  3: { text: 'Falha', component: <Close width={16} height={16} /> },
}

const ValuationMonitor = ({
  valuations,
  drawing,
  filterActive,
  getValuationById,
}) => {
  return (
    <Container filterActive={filterActive} drawing={drawing}>
      <Body>
        <Scroll>
          {!!valuations?.length &&
            valuations.map(item => {
              const statusNumber = isFinite(item.status)
                ? item.status
                : Number(valuationStatus[item.status])
              const createdAt = new Date(item.createdAt)
              const disabled = DISABLED_STATUS.includes(statusNumber)
              const areaVariation = (item.areaPercentMargin * item.area) / 100
              return (
                <Row
                  firstLevel
                  key={item.id}
                  onClick={() => (!disabled ? getValuationById(item.id) : null)}
                >
                  <Col width="100%" height="100%">
                    <Row
                      inner
                      justify="space-between"
                      alignItems="center"
                      title={statusNumber === 3 ? item.error : undefined}
                    >
                      <Pill>{`${createdAt.getDate()} ${createdAt.toLocaleString(
                        'pt-BR',
                        {
                          month: 'short',
                        },
                      )}`}</Pill>
                      <Pill status>{STATUS[statusNumber].component}</Pill>
                    </Row>

                    <Row hideOverflow color="#454E5B" inner>
                      <p>{item.fullAddress}</p>
                    </Row>

                    <Row color="#A1A9B4" inner>
                      <p>
                        {`${item.area - areaVariation} m² - ${item.area +
                          areaVariation} m²`}
                      </p>
                    </Row>
                  </Col>
                </Row>
              )
            })}
        </Scroll>
      </Body>
    </Container>
  )
}

export default ValuationMonitor
